import { Navigate, Route } from 'react-router-dom'

import { DelmanActivatePage } from '@/features/delman/ActivatePage'
import { DelmanAttendancePage } from '@/features/delman/AttendancePage'
import {
  DelmanKitchenTransferHandoverPage,
  DelmanKitchenTransferListPage,
} from '@/features/delman/DelmanKitchenTransferPage'
import { DelmanDeliveryDetailPage } from '@/features/delman/DeliveryDetailPage'
import { DelmanEntryRedirect } from '@/features/delman/DelmanEntryRedirect'
import { DelmanHandoverPage } from '@/features/delman/HandoverPage'
import { DelmanLoginPage } from '@/features/delman/LoginPage'
import { DelmanPickupReturnPage } from '@/features/delman/PickupReturnPage'
import { DelmanTripPage } from '@/features/delman/TripPage'
import { DelmanAppLayout } from '@/shared/layouts/DelmanAppLayout'
import { KitchenAuthLayout } from '@/shared/layouts/KitchenAuthLayout'

export const delmanRouteElements = (
  <>
      <Route path="/delman/handover" element={<Navigate to="/delman/trip" replace />} />

      <Route path="/delman">
        <Route element={<KitchenAuthLayout />}>
          <Route index element={<DelmanEntryRedirect />} />
          <Route path="activate" element={<DelmanActivatePage />} />
          <Route path="login" element={<DelmanLoginPage />} />
        </Route>
        <Route element={<DelmanAppLayout />}>
          <Route path="trip" element={<DelmanTripPage />} />
          <Route path="delivery/:deliveryId" element={<DelmanDeliveryDetailPage />} />
          <Route path="handover/:deliveryId" element={<DelmanHandoverPage />} />
          <Route path="pickup-retur" element={<DelmanPickupReturnPage />} />
          <Route path="absensi" element={<DelmanAttendancePage />} />
          <Route path="kitchen-transfer" element={<DelmanKitchenTransferListPage />} />
          <Route path="kitchen-transfer/:transferId" element={<DelmanKitchenTransferHandoverPage />} />
        </Route>
      </Route>
  </>
)
